import React from 'react';

const guides = [
  {
    name: "Swift Desire",
    role: "Swift Desire",
    description: "Prince Cab’s Swift Desire is perfect for solo travelers or small families. Known for its comfort and mileage, it’s ideal for city rides and airport transfers.",
    image: "/images/gallery/1.jpg",
  },
  {
    name: "Toyota Etios",
    role: "Toyota Etios",
    description: "Ride in style and comfort with Prince Cab’s Toyota Etios. Spacious and smooth, it's the preferred choice for local travel and day-long trips.",
    image: "/images/gallery/2.jpg",
  },
  {
    name: "Kia Carens",
    role: "Kia Carens",
    description: "The Kia Carens from Prince Cab offers premium comfort and ample space, making it an excellent option for family tours and long-distance travel.",
    image: "/images/gallery/3.jpg",
  },
  {
    name: "Ertiga",
    role: "Ertiga",
    description: "Choose the Ertiga from Prince Cab for a budget-friendly yet comfortable ride. Ideal for group travel, with enough room for both passengers and luggage.",
    image: "/images/gallery/4.jpg",
  },
  {
    name: "Innova Cab",
    role: "Innova Cab",
    description: "Prince Cab’s Innova is a favorite for outstation trips. With its powerful engine and roomy interiors, it ensures a relaxed journey for the entire group.",
    image: "/images/gallery/5.jpg",
  },
  {
    name: "Innova Crysta",
    role: "Innova Crysta",
    description: "Experience luxury on the road with Prince Cab’s Innova Crysta. Perfect for corporate travel, family tours, or VIP transportation with premium features.",
    image: "/images/gallery/6.jpg",
  },
];


const Ourfleet = () => {
  return (



<>


 <section className="inner-banner-wrap">
        <div
          className="inner-baner-container"
          style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
        >
          <div className="container">
            <div className="inner-banner-content">
              <h1 className="inner-title">Our Fleets</h1>
            </div>
          </div>
        </div>
        <div className="inner-shape"></div>
      </section>



    <div className="guide-page-section">
      <div className="container">
        <div className="row">
          {guides.map((guide, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="guide-content-wrap text-center">
                <figure className="guide-image borderr">
                  <img src={guide.image} alt={guide.name} />
                </figure>
                <div className="guide-content borderr">
                  <h3>{guide.name}</h3>
                  <h5>{guide.role}</h5>
                  <p>{guide.description}</p>
                 
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
</>
  );
};

export default Ourfleet;
